import type {SxProps} from '@mui/system';
import {ColorPalette} from 'theme';
import {Layout} from 'components/layout';
import {Text} from 'components/text';

type Props = {
  code: string;
};

const sx: SxProps = {
  borderRadius: 1,
  background: ColorPalette.beige,
  padding: 1,
};

export const ThesaurusCode: React.FC<Props> = ({code}) => {
  return (
    <Layout sx={sx}>
      <Text variant="body2">{code}</Text>
    </Layout>
  );
};
